import styled, { css } from 'styled-components';
import ButtonBase, {
  ButtonHeight,
  ButtonHeightSmall,
  ButtonWidth,
  ButtonBorderWidth,
  ButtonBorderStyle
} from './ButtonBase';

const blueButtonCore = css`
  /* default */
  color: ${props => props.theme.carvana.white.primary};
  background-color: ${props => props.theme.carvana.blue.primary};

  /* disabled */
  color: ${props => props.disabled && props.theme.carvana.gray.medium};
  background-color: ${props =>
    props.disabled && props.theme.carvana.gray.light};

  /* ghost */
  border-width: ${props => props.ghost && ButtonBorderWidth};
  border-style: ${props => props.ghost && ButtonBorderStyle};
  color: ${props => props.ghost && props.theme.carvana.blue.primary};
  background-color: ${props => props.ghost && 'transparent'};
  border-color: ${props => props.ghost && props.theme.carvana.blue.primary};

  /* ghost disabled */
  color: ${props =>
    props.ghost && props.disabled && props.theme.carvana.gray.light};
  background-color: ${props => props.ghost && props.disabled && 'transparent'};
  border-color: ${props =>
    props.ghost && props.disabled && props.theme.carvana.gray.light};

  height: ${props => (props.small ? ButtonHeightSmall : ButtonHeight)};
  width: ${props => props.width || ButtonWidth};

  &:hover {
    background-color: ${props => props.theme.carvana.blue.hover};

    color: ${props => props.ghost && props.theme.carvana.white.primary};
  }
`;

const BlueButton = styled(ButtonBase)`
  ${blueButtonCore};
`;

export default BlueButton;
